import React, { useState, useEffect } from "react";
import CssCodeEditor from "../../../components/CssCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const StyleTab = ({updateTestimonialTabData,testimonialTabData}) => {
     const [activeStyleColorSchemeTab, setActiveStyleColorSchemeTab] = useState("light");
    const [activeStyleElementsTab, setActiveStyleElementsTab] = useState("main");
    const [backgroundColor, setBackgroundColor] = useState(testimonialTabData.style_background_color);
    const [titleColor, setTitleColor] = useState(testimonialTabData.style_colors_title_color);
    const [captionColor, setCaptionColor] = useState(testimonialTabData.style_colors_caption_color);
    const [linksColor, setLinksColor] = useState(testimonialTabData.style_colors_links_color);
     const [selectedStyleTabTitleSizeSpacing, setSelectedStyleTabTitleSizeSpacing] = useState(testimonialTabData.style_colors_font_title_size);
    const [showStyleTabTitleSizeSpacingDropdown, setShowStyleTabTitleSizeSpacingDropdown] = useState(false);
    const layoutTabTitleSizeSpacingValues = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 30, 40, 50];
    
    const [selectedStyleTabCaptionSizeSpacing, setSelectedStyleTabCaptionSizeSpacing] = useState(testimonialTabData.style_colors_font_caption_size);
    const [showStyleTabCaptionSizeSpacingDropdown, setShowStyleTabCaptionSizeSpacingDropdown] = useState(false);
    const layoutTabCaptionSizeSpacingValues = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 30, 40, 50];
    const [ratingColor, setRatingColor] = useState(testimonialTabData.style_rating_color);
    const [styleTestimonalBackgroundColor, setStyleTestimonalBackgroundColor] = useState(testimonialTabData.style_testimonial_background_color);
    const [styleTestimonalTextColor, setStyleTestimonalTextColor] = useState(testimonialTabData.style_testimonial_testimonial_text_color);
    const [styleTestimonalReadMoreColor, setStyleTestimonalReadMoreColor] = useState(testimonialTabData.style_testimonial_read_more_color);
    const [styleTestimonalReviewerNameColor, setStyleTestimonalReviewerNameColor] = useState(testimonialTabData.style_testimonial_reviewer_name_color);
    const [styleTestimonalVerifiedBadgeColor, setStyleTestimonalVerifiedBadgeColor] = useState(testimonialTabData.style_testimonial_verified_badge_color);
    const [styleTestimonalCaptionColor, setStyleTestimonalCaptionColor] = useState(testimonialTabData.style_testimonial_caption_color);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(testimonialTabData.style_testimonial_custom_css);
    //Testimonal Rating Size type
    const [selectedStyleTabRatingSizeSpacing, setSelectedStyleTabRatingSizeSpacing] = useState(testimonialTabData.style_testimonial_rating_sizetype);
    const [showStyleTabRatingSizeSpacingDropdown, setShowStyleTabRatingSizeSpacingDropdown] = useState(false);
    const layoutTabRatingSizeSpacingValues = ['Small', 'Medium', 'Large', 'X-Large'];

    //Testimonal Text Font Size
    const [selectedStyleTabReviewTextFontSizeSpacing, setSelectedStyleTabReviewTextFontSizeSpacing] = useState(testimonialTabData.style_testimonial_testimonial_text_font_size);
        const [showStyleTabReviewTextFontSizeSpacingDropdown, setShowStyleTabReviewTextFontSizeSpacingDropdown] = useState(false);
        const layoutTabReviewTextFontSizeSpacingValues = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 30, 40, 50];
        
    //Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateTestimonialTabData("style_background_color", color.hex);
    };

    // Handlers Title Color Change
    const handleTitleColorChange = (color) => {
        setTitleColor(color.hex);
        updateTestimonialTabData("style_colors_title_color", color.hex);
    };

    // Handlers Caption Color Change
    const handleCaptionColorChange = (color) => {
        setCaptionColor(color.hex);
        updateTestimonialTabData("style_colors_caption_color", color.hex);
    };

    // Handlers Links Color Change
    const handleLinksColorChange = (color) => {
        setLinksColor(color.hex);
        updateTestimonialTabData("style_widget_title_links_color", color.hex);
    };

    // Handlers Review Title Size Change
    const toggleStyleTabTitleSizeSpacingDropdown = () => {
        setShowStyleTabTitleSizeSpacingDropdown(!showStyleTabTitleSizeSpacingDropdown);
    };
    const handleStyleTabTitleSizeSpacingSelect = (spacing) => {
        setSelectedStyleTabTitleSizeSpacing(spacing);
        setShowStyleTabTitleSizeSpacingDropdown(false);
        updateTestimonialTabData("style_colors_font_title_size", spacing); 
    };

    // Handlers Review Caption Size Change
    const toggleStyleTabCaptionSizeSpacingDropdown = () => {
        setShowStyleTabCaptionSizeSpacingDropdown(!showStyleTabCaptionSizeSpacingDropdown);
    };
    const handleStyleTabCaptionSizeSpacingSelect = (spacing) => {
        setSelectedStyleTabCaptionSizeSpacing(spacing);
        setShowStyleTabCaptionSizeSpacingDropdown(false);
        updateTestimonialTabData("style_colors_font_caption_size", spacing); 
    };

    // Handlers Stars Color Change
    const handleRatingStarsColorChange = (color) => {
        setRatingColor(color.hex);
        updateTestimonialTabData("style_rating_color", color.hex);
    };

    // Handlers Testimonal Background Color Change
    const handleTestimonalBackgroundColorChange = (color) => {
        setStyleTestimonalBackgroundColor(color.hex);
        updateTestimonialTabData("style_testimonial_background_color", color.hex);
    };

    // Handlers Testimonal Text Color Change
    const handleTestimonalTextColorChange = (color) => {
        setStyleTestimonalTextColor(color.hex);
        updateTestimonialTabData("style_testimonial_testimonial_text_color", color.hex);
    };

     // Handlers Testimonal Read More Color Change
     const handleTestimonalReadMoreColorChange = (color) => {
        setStyleTestimonalReadMoreColor(color.hex);
        updateTestimonialTabData("style_testimonial_read_more_color", color.hex);
    };

    // Handlers Testimonal Reviewer Name Color Change
    const handleTestimonalReviewerNameColorChange = (color) => {
        setStyleTestimonalReviewerNameColor(color.hex);
        updateTestimonialTabData("style_testimonial_reviewer_name_color", color.hex);
    };

    // Handlers Testimonal Verified Badge Color Change
    const handleTestimonalVerifiedBadgeColorChange = (color) => {
        setStyleTestimonalVerifiedBadgeColor(color.hex);
        updateTestimonialTabData("style_testimonial_verified_badge_color", color.hex);
    };

    // Handlers Testimonal Caption Color Change
    const handleTestimonalCaptionColorChange = (color) => {
        setStyleTestimonalCaptionColor(color.hex);
        updateTestimonialTabData("style_testimonial_caption_color", color.hex);
    };

    // Handlers Testimonal Rating Size Change
    const toggleStyleTabRatingSizeSpacingDropdown = () => {
        setShowStyleTabRatingSizeSpacingDropdown(!showStyleTabRatingSizeSpacingDropdown);
    };
    const handleStyleTabRatingSizeSpacingSelect = (spacing) => {
        setSelectedStyleTabRatingSizeSpacing(spacing);
        setShowStyleTabRatingSizeSpacingDropdown(false);
        updateTestimonialTabData("style_testimonial_rating_sizetype", spacing); 
    };

    // Handlers Testimonal Text Font Size Change
    const toggleStyleTabReviewTextFontSizeSpacingDropdown = () => {
        setShowStyleTabReviewTextFontSizeSpacingDropdown(!showStyleTabReviewTextFontSizeSpacingDropdown);
    };
    const handleStyleTabReviewTextFontSizeSpacingSelect = (spacing) => {
        setSelectedStyleTabReviewTextFontSizeSpacing(spacing);
        setShowStyleTabReviewTextFontSizeSpacingDropdown(false);
        updateTestimonialTabData("style_testimonial_testimonial_text_font_size", spacing); 
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateTestimonialTabData("style_testimonial_custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    return (
        <div className="testimonials-side-baar-style-tab">
            {activeStyleElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Color Scheme</span>
                            <div className="light-dark-button">
                                <button className={activeStyleColorSchemeTab === "light" ? "light-button active" : ""} onClick={() => setActiveStyleColorSchemeTab("light")}>Light</button>
                                {/*<button className={activeStyleColorSchemeTab === "dark" ? "dark-button active" : ""} onClick={() => setActiveStyleColorSchemeTab("dark")}>Dark</button>*/}
                            </div>
                        </div>
                        {/*<div className="box-header-row">
                            <span>Accent Color</span>
                            {activeStyleColorSchemeTab === "light" &&
                                <div className="accent-color">
                                    <div className="accent-color-list">
                                        <input type="radio" name="color" id="red" value="red" />
                                        <label for="red"><span className="red"></span></label>
                                    </div>
                                </div>}
                            {activeStyleColorSchemeTab === "dark" &&
                                <div className="accent-color">
                                    <div className="accent-color-list">
                                        <input type="radio" name="color" id="red" value="red" />
                                        <label for="red"><span className="red"></span></label>
                                    </div>
                                </div>}
                        </div>*/}
                        {/*<div className="box-header-row last-border-none">
                            <span>Font</span>
                            <div className="salcete-font">
                                <button><em>Default <i className="fa fa-caret-down" aria-hidden="true"></i></em></button>
                            </div>
                        </div>*/}
                    </div>
                    {/*<div className="side-baar-box-header">
                        <div className="box-header-row last-border-none">
                            <span>Show Icon in Button</span>
                            <em>Start-To-Finish Timer</em>
                        </div>
                    </div>*/}
                    <div className="customize-elements">Customize Elements</div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveStyleElementsTab("background")}>Background <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveStyleElementsTab("widget_title")}>Widget Title <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveStyleElementsTab("rating")}>Rating <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveStyleElementsTab("testimonial")}>Testimonial <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            {/*<li>
                                <button onClick={() => setActiveStyleElementsTab("navigation")}>Navigation Arrows <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveStyleElementsTab("pagination")}>Pagination <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>*/}
                            <li>
                                <button onClick={() => setActiveStyleElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeStyleElementsTab === "background" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Background</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={backgroundColor} setColor={setBackgroundColor} onChangeComplete={handleBackgroundColorChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleElementsTab === "widget_title" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Widget Title</span>
                        <div className="side-baar-box-header">
                            {/*<div className="box-header-row">
                                <span>Alignment</span>
                                <em>
                                    <div className="alignment-buton">
                                        <button><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M9.167 14.4a.6.6 0 0 1 .097 1.192l-.097.008H2.5a.6.6 0 0 1-.097-1.192L2.5 14.4h6.667Zm8.333-3.333a.6.6 0 0 1 .097 1.192l-.097.008h-15a.6.6 0 0 1-.097-1.192l.097-.008h15Zm-3.333-3.334a.6.6 0 0 1 .097 1.192l-.097.008H2.5a.6.6 0 0 1-.097-1.192l.097-.008h11.667ZM17.5 4.4a.6.6 0 0 1 .097 1.192L17.5 5.6h-15a.6.6 0 0 1-.097-1.192L2.5 4.4h15Z"></path></svg></button>
                                        <button><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M13.333 14.4a.6.6 0 0 1 .098 1.192l-.098.008H6.667a.6.6 0 0 1-.098-1.192l.098-.008h6.666Zm4.167-3.333a.6.6 0 0 1 .097 1.192l-.097.008h-15a.6.6 0 0 1-.097-1.192l.097-.008h15Zm-1.667-3.334a.6.6 0 0 1 .098 1.192l-.098.008H4.167a.6.6 0 0 1-.098-1.192l.098-.008h11.666ZM17.5 4.4a.6.6 0 0 1 .097 1.192L17.5 5.6h-15a.6.6 0 0 1-.097-1.192L2.5 4.4h15Z"></path></svg></button>
                                        <button><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M17.5 14.4a.6.6 0 0 1 .097 1.192l-.097.008h-6.667a.6.6 0 0 1-.097-1.192l.097-.008H17.5Zm0-3.333a.6.6 0 0 1 .097 1.192l-.097.008h-15a.6.6 0 0 1-.097-1.192l.097-.008h15Zm0-3.334a.6.6 0 0 1 .097 1.192l-.097.008H5.833a.6.6 0 0 1-.097-1.192l.097-.008H17.5Zm0-3.333a.6.6 0 0 1 .097 1.192L17.5 5.6h-15a.6.6 0 0 1-.097-1.192L2.5 4.4h15Z"></path></svg></button>
                                    </div>
                                </em>
                            </div>*/}
                        </div>
                        <p>Colors</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row widget-title-color">
                                <span>Title Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={titleColor} setColor={setTitleColor} onChangeComplete={handleTitleColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Caption Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={captionColor} setColor={setCaptionColor} onChangeComplete={handleCaptionColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Links Color</span>
                                <div className="color-pikr-box">
                                <ColorPicker color={linksColor} setColor={setLinksColor} onChangeComplete={handleLinksColorChange} />
                                </div>
                            </div>
                        </div>
                        <p>Colors</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Title Size</span>
                                <em onClick={toggleStyleTabTitleSizeSpacingDropdown}>{selectedStyleTabTitleSizeSpacing}px</em>
                                {showStyleTabTitleSizeSpacingDropdown && (
                                    <ul className="dropdown-list">
                                        {layoutTabTitleSizeSpacingValues.map((spacing) => (
                                            <li key={spacing} onClick={() => handleStyleTabTitleSizeSpacingSelect(spacing)}>
                                                {spacing}px
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <div className="box-header-row">
                                <span>Caption Size</span>
                                <em onClick={toggleStyleTabCaptionSizeSpacingDropdown}>{selectedStyleTabCaptionSizeSpacing}px</em>
                                {showStyleTabCaptionSizeSpacingDropdown && (
                                    <ul className="dropdown-list">
                                        {layoutTabCaptionSizeSpacingValues.map((spacing) => (
                                            <li key={spacing} onClick={() => handleStyleTabCaptionSizeSpacingSelect(spacing)}>
                                                {spacing}px
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleElementsTab === "rating" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Rating</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row widget-title-color">
                                <span>Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={ratingColor} setColor={setRatingColor} onChangeComplete={handleRatingStarsColorChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleElementsTab === "testimonial" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Testimonial</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleTestimonalBackgroundColor} setColor={setStyleTestimonalBackgroundColor} onChangeComplete={handleTestimonalBackgroundColorChange} />
                                </div>
                            </div>
                            {/*<div className="box-header-row">
                                <span>Testimonial Outline Color</span>
                                <em><button className="bg-color-btton"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M3.483 6.803c-.507.944-.76 1.788-.76 2.53 0 2.946 2.377 5.334 5.31 5.334a5.268 5.268 0 0 0 2.75-.77ZM2.515 3.75a.597.597 0 0 0-.012.844l.013.012 10.088 9.796a.632.632 0 0 0 .88 0 .597.597 0 0 0 .013-.844l-.013-.012L3.396 3.75a.632.632 0 0 0-.88 0Zm5.518-2.417C6.925 2.388 5.991 3.373 5.23 4.29l7.583 7.37c.34-.704.53-1.493.53-2.327 0-1.963-1.77-4.63-5.31-8Z"></path></svg></button></em>
                            </div>*/}
                            <div className="box-header-row widget-title-color">
                                <span>Testimonial Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleTestimonalTextColor} setColor={setStyleTestimonalTextColor} onChangeComplete={handleTestimonalTextColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Read More Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleTestimonalReadMoreColor} setColor={setStyleTestimonalReadMoreColor} onChangeComplete={handleTestimonalReadMoreColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Reviewer Name Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleTestimonalReviewerNameColor} setColor={setStyleTestimonalReviewerNameColor} onChangeComplete={handleTestimonalReviewerNameColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Verified Badge Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleTestimonalVerifiedBadgeColor} setColor={setStyleTestimonalVerifiedBadgeColor} onChangeComplete={handleTestimonalVerifiedBadgeColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Caption Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleTestimonalCaptionColor} setColor={setStyleTestimonalCaptionColor} onChangeComplete={handleTestimonalCaptionColorChange} />
                                </div>
                            </div>
                            {/*<div className="box-header-row widget-title-color">
                                <span>Website URL Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={websiteURLColor} setColor={setwebsiteURLColor} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Social Profile Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={socialProfileColor} setColor={setsocialProfileColor} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Social Profile Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={socialProfileBackgroundColor} setColor={setsocialProfileBackgroundColor} />
                                </div>
                            </div>*/}
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Rating Size</span>
                                <div className="color-pikr-box">
                                    <em onClick={toggleStyleTabRatingSizeSpacingDropdown}>{selectedStyleTabRatingSizeSpacing}</em>
                                    {showStyleTabRatingSizeSpacingDropdown && (
                                        <ul className="dropdown-list">
                                            {layoutTabRatingSizeSpacingValues.map((spacing) => (
                                                <li key={spacing} onClick={() => handleStyleTabRatingSizeSpacingSelect(spacing)}>
                                                    {spacing}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Testimonial Text Font Size</span>
                                <em onClick={toggleStyleTabReviewTextFontSizeSpacingDropdown}>{selectedStyleTabReviewTextFontSizeSpacing}px</em>
                                {showStyleTabReviewTextFontSizeSpacingDropdown && (
                                    <ul className="dropdown-list">
                                        {layoutTabReviewTextFontSizeSpacingValues.map((spacing) => (
                                            <li key={spacing} onClick={() => handleStyleTabReviewTextFontSizeSpacingSelect(spacing)}>
                                                {spacing}px
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/*{activeStyleElementsTab === "navigation" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Navigation</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row widget-title-color">
                                <span>Arrow Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={arrowBackgroundColor} setColor={setarrowBackgroundColor} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Arrow Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={arrowColor} setColor={setarrowColor} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Arrow Background Color on Hover</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={arrowBackgroundColoronHover} setColor={setarrowBackgroundColoronHover} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Arrow Color on Hover</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={arrowColoronHover} setColor={setarrowColoronHover} />
                                </div>
                            </div>
                            <div className="box-header-row widget-title-color">
                                <span>Arrow Size</span>
                                <em>
                                    12px
                                </em>
                                <div className="slider-container">
                                    <input min="200" max="1920" type="range" value="200" />
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleElementsTab === "pagination" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Pagination</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row widget-title-color">
                                <span>Pagination Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={paginationColor} setColor={setpaginationColor} />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}*/}

            {activeStyleElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Css</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;